import { Button, Drawer, Form, Input, Select, Space } from "antd";
import React from "react";
import { connect } from "react-redux";
import {
  createInventoryItem,
  editInventoryItem,
  fetchInventorySubCategories,
} from "../../../../../api/inventory.api";
import styles from "./form.module.scss";

const taxTypeValues = {
  cgst_sgst: "SGST/CGST",
  igst: "IGST",
};

const AddItemDrawer = ({
  open,
  refresh,
  onClose,
  item = null,
  edit = false,
  settings,
}) => {
  const [subCategories, setSubCategories] = React.useState([]);

  const [form] = Form.useForm();

  const getSubCategories = React.useCallback(async () => {
    try {
      const subCategories = await fetchInventorySubCategories();
      setSubCategories(
        subCategories.sort((a, b) => {
          return b.id - a.id;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  const submit = React.useCallback(
    async (values) => {
      try {
        if (edit && item?.id) {
          await editInventoryItem(item.id, {
            ...values,
            branch: settings?.branch?.id,
          });
        } else {
          await createInventoryItem({
            ...values,
            branch: settings?.branch?.id,
          });
        }
        refresh();
        form.resetFields();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
    [edit, refresh, form, onClose, item?.id, settings?.branch?.id]
  );

  React.useEffect(() => {
    getSubCategories();
  }, [getSubCategories]);

  React.useEffect(() => {
    if (edit) {
      form.setFieldsValue(item);
    }
  }, [item, edit]);

  return (
    <Drawer
      title="Add new item"
      visible={open}
      onClose={onClose}
      extra={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={form.submit}>
            Save
          </Button>
        </Space>
      }
      onClose={onClose}
    >
      <Form
        layout="vertical"
        onFinish={submit}
        form={form}
        className={styles.form}
        width={500}
      >
        <Form.Item
          name="product_name"
          label="Product Name"
          rules={[
            {
              required: true,
              message: "Please enter product name",
            },
          ]}
          className={styles.spanner}
        >
          <Input placeholder="Enter product name" />
        </Form.Item>
        <Form.Item
          name="inventory_subcategory"
          label="Subcategory Name"
          rules={[
            {
              required: true,
              message: "Please select sub category",
            },
          ]}
          className={styles.spanner}
        >
          <Select placeholder="Select sub category">
            {subCategories.map((subCategory) => (
              <Select.Option key={subCategory.id} value={subCategory.id}>
                {subCategory.subcategory_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="unit" label="Unit">
          <Input placeholder="Enter unit" />
        </Form.Item>
        <Form.Item name="cost_price" label="Cost Price">
          <Input placeholder="Enter cost price" type="number" />
        </Form.Item>
        <Form.Item name="selling_price" label="Selling Price">
          <Input placeholder="Enter selling price" type="number" />
        </Form.Item>
        <Form.Item name="tax_value" label="Tax Value">
          <Select placeholder="Select tax value">
            {[5, 12, 18, 28].map((taxValue) => (
              <Select.Option key={taxValue} value={taxValue}>
                {taxValue}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="tax_type" label="Tax Type">
          <Select placeholder="Select tax type">
            {Object.keys(taxTypeValues).map((taxType) => (
              <Select.Option key={taxType} value={taxType}>
                {taxTypeValues[taxType]}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="stock" label="Stock">
          <Input placeholder="Enter stock" type="number" />
        </Form.Item>
        <Form.Item name="discount" label="Discount">
          <Input placeholder="Enter discount" type="number" />
        </Form.Item>
        <Form.Item name="hsn_code" label="HSN Code">
          <Input placeholder="Enter HSN code" />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(AddItemDrawer);
